var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('base-header',{staticClass:"pb-9 pt-4",attrs:{"type":_vm.$route.meta.headerClass ? _vm.$route.meta.headerClass : 'success'}}),_c('div',{staticClass:"mt--7"},[_c('div',{staticClass:"container-fluid mt--7"},[_c('new-inspiration')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }